import { ImageIcon } from "lucide-react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ImageLibraryDialog } from "@src/components/Dialogs/ImageLibraryDialog";
import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";
import { useDialog } from "@src/hooks/dialog";

import { InputProps } from "./types";

export const IconInput = ({ label, value, onChange }: InputProps) => {
  const theme = useTheme();
  const imageLibraryDialog = useDialog("imageLibrary");

  const handleSelectIcon = () => {
    imageLibraryDialog.open({
      id: imageLibraryDialog.id,
      onUpdateImage: onChange,
    });
  };

  return (
    <>
      <Stack spacing={1}>
        <Panel.Label>
          {label}
          <Panel.Optional />
        </Panel.Label>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{
            border: `1px solid ${theme.igBorders.core.default}`,
            borderRadius: "8px",
            px: 2,
            py: 1.5,
          }}
        >
          {value ? (
            <img
              src={value}
              alt="Icon"
              style={{
                width: 32,
                height: 32,
                objectFit: "contain",
                borderRadius: 4,
              }}
            />
          ) : (
            <ImageIcon size={24} color={theme.palette.text.secondary} />
          )}
          <IgTypography
            variant="body2"
            color="text.secondary"
            sx={{ flex: 1 }}
            noWrap
          >
            {value ? value.split("/").pop() : "No icon selected"}
          </IgTypography>
          <IgButton
            variant="outlined"
            color="secondary"
            size="small"
            onClick={handleSelectIcon}
          >
            Choose
          </IgButton>
        </Stack>
      </Stack>
      <ImageLibraryDialog id={imageLibraryDialog.id} />
    </>
  );
};
